<!-- 
  新建 入库单特殊字段
  prop: 
    item: 绑定对象
    form: form表单数据对象
  emit: 
    showProduct: 打开关联商品弹窗
 -->

<template>
  <div class="redundant">
    <!-- 仓库 -->
    <template v-if="item.attr === 'warehouseId'">
      <remote-select
        module="warehouse"
        moduleName="instock"
        :item="item"
        :form="form"
        @emitObj="getchangeHouse">
      </remote-select>
    </template>
    <!-- 负责人 -->
    <template v-if="item.attr === 'managerId'">
      <v-manager
        :item="item"
        :form="form">
      </v-manager>
    </template>
    <!-- 关联单据 -->
    <template v-if="item.attr === 'refId'">
      <el-input
        v-if="item.nonEditable===1"
        :disabled="true"
        :value="item.attrValue.value || '无'">
      </el-input>
      <remote-select
        v-else-if="moduleName(form.type)"
        @emitObj="getSelectProducts"
        moduleName="instock"
        :always="true"
        :module='moduleName(form.type)'
        :item="item"
        :form="form">
      </remote-select>
      <span v-else>无</span>
    </template>
    <!-- 盘点产品 -->
<!--     <template v-if="item.attr === 'products'">
      <div class="products">
        <div class="v-area">
          <template v-if="form[item.attr] && form[item.attr].length">{{form[item.attr] | productLen}}</template>
          <template v-else>暂无关联产品</template>
        </div>
        <span class="add-btn" @click="emitParent(item.nonEditable)">选择</span>
      </div>
    </template> -->
    <!-- 入库产品 -->
    <!-- <template v-if="item.attr === 'products'">
      <link-product :instockproduct="instockproduct" :item="item" :form="form" :attrValue="item.attrValue"  @emitProduct="getProduct" :refId="this.form.refId"></link-product>
      <template v-if="false">暂无关联产品</template>
    </template>  -->
  </div>
</template>

<script>
// import Vue from 'vue'
import * as api from 'src/api'
import { mapActions } from 'vuex'
import remoteSelect from '../remote-select'
import vManager from '../manager'
// import linkProduct from '../linkProduct'
export default {
  props: ['item', 'form', 'detailId'],
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'setAttr',
      'updateSelect'
    ]),
    emitParent (nonEditable) {
      // selectOnly 表示不能选择关联合同之外的产品，且限制产品数量
      let type = this.form.type
      let name = ['purchase', 'contract'].indexOf(type) > -1 ? 'selectOnly' : ''
      this.$emit('showProduct', name, nonEditable)
    },
    moduleName (type) {
      console.log('instockType', type)
      if (type === '1') {
        return 'purchase'
      } else if (type === '2') {
        return 'contract'
      } else if (type === '3') {
        return 'inventory'
      } else if (type === '4') {
        return 'transfer'
      } else if (type === '7') { // 生产成品入库
        return 'finshedProduct'
      } else if (type === '8') { // 退料入库
        return 'returnedMateriel'
      } else {
        this.form.refId = {}
        this.setAttr('refId')
        return ''
      }
    },
    getSelectProducts (obj) {
      console.log(5555, obj)
      if (obj) {
        const type = this.form.type
        let url
        let params = {}
        // 采购入库
        if (type === '1') {
          url = `/purchase/purchaseProductList.html`
          params = {
            fromInstock: 1,
            purchaseId: obj.id,
            instockId: this.detailId || 0
          }
        } else if (type === '2') {
          url = '/contractApi/getContractProducts.html'
          params = {
            instockId: this.id || 0,
            id: obj.id
          }
        } else if (type === '3') {
          url = `/inventory/inventoryProductList.html`
          params = {
            fromInstock: 1,
            inventoryId: obj.id,
            // 盘盈
            type: 1
          }
          this.changeWareHouse(obj)
        } else if (type === '4') {
          url = `/transfer/transferProductList.html`
          params = {
            fromInstock: 1,
            transferId: obj.id
          }
          this.changeWareHouse(obj)
        // 生产成品入库、退料入库
        } else if (type === '7' || type === '8') {
          url = `/productionOrder/productionOrderProductList.html`
          params = {
            fromInstock: 1,
            productionOrderId: obj.id
          }
          if (type === '7') {
            params.type = 'finshedProduct'
          } else if (type === '8') {
            params.type = 'returnedMateriel'
          }
          this.changeWareHouse(obj)
        } else {
          return
        }
        params.refType = type // 选择关联时候要传入库类型
        api.post(url, params, (data) => {
          // let instockP = data.productList
          // instockP.map((obj) => {
          //   return obj.result.map((item) => {
          //     if (item.attr === 'warehouse') {
          //       Vue.set(item, 'valueArrMap', this.stock)
          //     }
          //   })
          // })
          // console.log(104, instockP)
          this.$emit('instockProList', data.productList)
          // this.getvalue()
          // 数据变更时，手动触发验证
          // this.setAttr('products')
        })
      } else {
        // 删除关联单据时，清空关联产品
        this.form.products = []
        this.$emit('emptyPro')
      }
    },

    // 动态改变所选仓库
    changeWareHouse (obj) {
      if (obj.warehouseObj) {
        this.form.warehouseId = obj.warehouseObj
      }
    },
    // 仓库改变时候
    getchangeHouse (val) {
      console.log(500000, val)
      this.$emit('getchangeHouse')
    }
  },
  filters: {
    productLen (arr) {
      let num = 0
      arr.forEach((item) => {
        num += item.num
      })
      num = Number(num.toFixed(5))
      return `${arr.length}种产品${num}件`
    }
  },
  components: {
    vManager,
    remoteSelect
    // linkProduct
  },
  watch: {
    // form: {
    //   handler () {
    //     console.log(3434, this.form.refId)
    //     // 其他入库时候清空产品（入库单）
    //     if (!this.form.refId.id) {
    //       this.instockproduct = []
    //     }
    //   },
    //   deep: true
    // }
  }
}
</script>
<style lang="less" scoped>
  @import '../../../assets/less/fieldtype-products.less';
</style>


// WEBPACK FOOTER //
// index.vue?67c5828d